@if (authService.hasPermission(Permission.ProductsFull)) {
  <button
    mat-menu-item
    (click)="onDelete()"
    >
    <mat-icon color="warn">delete</mat-icon>
    <span>Delete</span>
  </button>
}
